export default "__VITE_ASSET__DowP5YI8__"